export default __webpack_public_path__ + "static/media/Pacifico-Regular.93cd59ff.ttf";